import { render, staticRenderFns } from "./PublicacionPreview.vue?vue&type=template&id=3e163463&scoped=true&"
import script from "./PublicacionPreview.vue?vue&type=script&lang=ts&"
export * from "./PublicacionPreview.vue?vue&type=script&lang=ts&"
import style1 from "./PublicacionPreview.vue?vue&type=style&index=1&id=3e163463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e163463",
  null
  
)

export default component.exports